import Button from '@/components/Button/Button';
import { ButtonVariants } from '@/components/Button/Button.types';
import Modal from '@/components/Modal/Modal';
import styles from './ModalLockedProducts.module.css';
import { StoreProduct } from '@/types/menus.types';
import { Box, Typography } from '@mui/material';
import { useTranslation } from 'react-i18next';

export interface IProps {
  isOpen: boolean;
  lockedProducts: StoreProduct[];
  onClose: () => void;
}

const ModalLockedStores = (props: IProps) => {
  const { t } = useTranslation();
  const { isOpen, onClose, lockedProducts } = props;
  return (
    <Modal
      className={styles.modal}
      isOpen={isOpen}
      onClose={() => onClose()}
      headerContent={t('menuDetails.modalLockedProducts.lockedProducts')}
      showTitleDivider
      bodyClass={styles.modalBodyOver}
      bodyContent={
        <Box p={3}>
          <div className={styles.body}>
            <p className={styles.message}>{t('menuDetails.modalLockedProducts.theseProductsWereNotSelected')}</p>

            <ul style={{ listStyle: 'unset', fontSize: '1.5em', paddingLeft: '20px' }}>
              {lockedProducts.map((prod) => (
                <li key={prod.productCode}>
                  <Typography className={styles.message} component="p" fontSize="1.6rem" pl={0}>
                    {`${prod.productName}, ${prod.productDescription}`}
                  </Typography>
                </li>
              ))}
            </ul>
          </div>
        </Box>
      }
      footerContent={
        <div className={styles.buttons}>
          <Button
            style={{ width: '12.5em', display: 'flex', justifyContent: 'center' }}
            variant={ButtonVariants.Primary}
            onClick={() => onClose()}
            type="button"
          >
            Close
          </Button>
        </div>
      }
    />
  );
};
export default ModalLockedStores;
